export const OCCUPANCY_TYPE = [
  "Main Residence",
  "Seasonal Residence",
  "Vacant Residence",
  "Tenant Occupied",
  "Landlord",
];
